import { render } from "./AuthorBlock.vue?vue&type=template&id=a9f1d4e6"
import script from "./AuthorBlock.vue?vue&type=script&lang=js"
export * from "./AuthorBlock.vue?vue&type=script&lang=js"

import "./AuthorBlock.vue?vue&type=style&index=0&id=a9f1d4e6&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__